var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { ViewChild, Component, Output, EventEmitter } from '@angular/core';
import { Headers, RequestOptions } from '@angular/http';
import { CommonService } from '../../services/common.service';
import { UsuarioService } from '../../services/usuario.service';
import { Message } from '../../common/dialog/mensaje.component';
import { MensajeConfig } from '../../common/dialog/mensaje.config';
var DemandaComponent = (function () {
    function DemandaComponent(_usrService, _comService) {
        this._usrService = _usrService;
        this._comService = _comService;
        this.files = [];
        this.onComplete = new EventEmitter(false);
        this.instanceId = Math.floor(Math.random() * 1000000);
    }
    DemandaComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.msgPopup.onClick.subscribe(function (event) { _this.onAceptarSussess(event); });
    };
    DemandaComponent.prototype.onAceptarSussess = function (res) {
        //console.log("");
    };
    DemandaComponent.prototype.fileChange = function (event) {
        var fileList = event.target.files;
        if (fileList.length > 0) {
            var file = fileList[0];
            var formData = new FormData();
            formData.append('uploadFile', file, file.name);
            var headers = new Headers();
            headers.append('Content-Type', 'multipart/form-data');
            headers.append('Accept', 'application/json');
            var options = new RequestOptions({ headers: headers });
        }
    };
    DemandaComponent.prototype.onChange = function (event) {
        //this.files = this.files.concat([].slice.call(event.target.files))
        var fileList = event.target.files;
        var error = false;
        for (var _i = 0; _i < fileList.length; _i++) {
            var file = fileList[_i];
            var name_1 = file.name.replace(/([^a-zA-Z0-9 ñÑÁÉÍÓÚÜüñáéíóú.]+)/gi, '');
            if (name_1 !== file.name) {
                error = true;
            }
        }
        if (error) {
            this.mensajeConfigSource = new MensajeConfig("Confirmación", false, "", true, "Aceptar");
            this.msgPopup.showMessage(this._comService.getConfiguracion('AVISODEMAD'));
        }
        this.files = this.files.concat([].slice.call(fileList));
    };
    DemandaComponent.prototype.onChangeFile = function (event) {
        this.demanda = [].slice.call(event.target.files);
        this.validateData();
    };
    DemandaComponent.prototype.deleteFile = function (index) {
        this.files.splice(index, 1);
        this.validateData();
    };
    DemandaComponent.prototype.delete = function (index) {
        this.demanda.splice(index, 1);
        this.validateData();
    };
    DemandaComponent.prototype.validateData = function () {
        if (this.demanda.length == 0) {
            this.onComplete.emit(false);
            return;
        }
        this.onComplete.emit(true);
    };
    return DemandaComponent;
}());
__decorate([
    Output(),
    __metadata("design:type", EventEmitter)
], DemandaComponent.prototype, "onComplete", void 0);
__decorate([
    ViewChild(Message),
    __metadata("design:type", Message)
], DemandaComponent.prototype, "msgPopup", void 0);
DemandaComponent = __decorate([
    Component({
        moduleId: module.id,
        selector: 'demanda',
        templateUrl: 'demanda.component.html'
    }),
    __metadata("design:paramtypes", [UsuarioService,
        CommonService])
], DemandaComponent);
export { DemandaComponent };
//# sourceMappingURL=demanda.component.js.map